import React from "react";
import settingsImg from "../../Assets/Images/settings-preview.svg";
import placeHolderImg from "../../Assets/Images/placeholder.png";
import playwhite from "../../Assets/Images/static/play-white.png";

const VideoPreview = ({
  image,

  updateOpenArrayState,
  sectionId,
}) => {
  console.log("videoooo");
  const handleClickSection = () => {
    updateOpenArrayState(sectionId);
  };
  return (
    <div className="containerPreviewImage mt-3">
      <div className="border position-relative">
        <img
          className="d-inline-flex"
          style={{
            width: "100" + "%",
            height: 165 + "px",

            backgroundImage: `url(${image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          alt=""
        />
        <img
          className="position-absolute top-0 start-0 bottom-0 end-0 m-auto"
          src={playwhite}
          alt=""
        />
      </div>
      <div className="overlay1" onClick={handleClickSection}>
        <img src={settingsImg} />
      </div>
    </div>
  );
};

export default VideoPreview;
